import { useCallback, useEffect } from 'react';
import { SET_STEP, SET_TOTAL_STEPS } from '../../events';

const dispatchNumber = (name: string, val: number) => {
  window.dispatchEvent(new CustomEvent(name, { detail: val }));
};

/**
 * Provides a hook to update the stepper values. Can optionally set the initial number of steps
 * and current step index.
 * */
function useUpdateStepper(initialTotalSteps?: number, initialStep?: number) {
  const setStep = useCallback((step: number) => dispatchNumber(SET_STEP, step), []);
  const setTotalSteps = useCallback((steps: number) => dispatchNumber(SET_TOTAL_STEPS, steps), []);

  useEffect(() => {
    if (initialStep !== undefined) setStep(initialStep);
    if (initialTotalSteps !== undefined) setTotalSteps(initialTotalSteps);
  }, [initialStep, initialTotalSteps, setStep, setTotalSteps]);

  return { setStep, setTotalSteps };
}

export default useUpdateStepper;
